/* ==========================================================================
   basis-eeat.js — permet de REPLIER le volet ouvert
   --------------------------------------------------------------------------
   Le composant fonctionne sans ce fichier : la bascule entre volets est
   entièrement CSS (input[type=radio] + :has()). Ce script n'ajoute qu'une
   chose, impossible en CSS pur : décocher le radio déjà coché pour refermer
   le panneau et revenir à « aucun volet ouvert ».

   Pourquoi ce n'est pas faisable sans JS : un radio coché ne se décoche pas
   au clic, c'est le comportement natif qui garantit qu'une option reste
   toujours sélectionnée dans un groupe. Une checkbox se décocherait, mais
   autoriserait plusieurs panneaux ouverts en même temps.

   Délégation sur `document` + garde d'initialisation : le snippet peut être
   rendu plusieurs fois sur une page (deux blocs dans un même article), le
   script serait alors chargé plusieurs fois. Un seul écouteur est posé.

   Dégradation : sans JS, on garde le comportement onglets — un volet est
   toujours ouvert. Rien ne casse.
   ========================================================================== */

(function () {
  "use strict";

  if (window.__basisEeatInit) return;
  window.__basisEeatInit = true;

  document.addEventListener("click", function (event) {
    var label = event.target.closest(".eeat__seg");
    if (!label) return;

    var input = document.getElementById(label.htmlFor);
    if (!input || input.type !== "radio") return;

    // Le radio est déjà coché au moment où le clic sur le label remonte :
    // c'est donc un reclic sur le volet ouvert -> on referme.
    if (input.checked) {
      event.preventDefault();
      input.checked = false;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  });
})();
